<template>
  <div class="wendemand">
    <div class="wendemandLoading" v-if="loading" v-loading="true"></div>
    <div class="wendemandTitle">
      <div>{{ itemByNeedNo.channelTypeName }}方案</div>
    </div>
    <div class="wendemandContainer">
      <div class="demandmation">需求信息</div>
      <div class="demandtime">
         
        <div>
           <span>需求编号：</span
          ><span>{{ itemByNeedNo.needNo ? itemByNeedNo.needNo : "-" }}</span>
        </div>
          
        <div>
            <span>渠道：</span
          ><span>{{
            itemByNeedNo.channel ? itemByNeedNo.channel : "百度"
          }}</span>
        </div>

        <div>
            <span>需求类型：</span
          ><span>{{
            itemByNeedNo.typeName ? itemByNeedNo.typeName : "-"
          }}</span>
        </div>

        <div>
            <span>联系电话：</span
          ><span>{{
            itemByNeedNo.publishMobile ? itemByNeedNo.publishMobile : "-"
          }}</span>
        </div>
        <div>
            <span>用户名：</span
          ><span>{{
            itemByNeedNo.publishName ? itemByNeedNo.publishName : "-"
          }}</span>
        </div>

             
        <div>
          <span>需求状态：</span>
          <span style="color: rgba(254, 106, 1, 1)">{{
            getStatus(itemByNeedNo.status)
          }}</span>
                        
        </div>
        <div>
            <span>申请区域：</span
          ><span>{{ itemByNeedNo.city ? itemByNeedNo.city : "-" }}</span>
        </div>

        <div>
            <span>创建时间：</span
          ><span>{{
            itemByNeedNo.created_at ? itemByNeedNo.created_at : "-"
          }}</span>
        </div>

        <div class="demanddetail">
                              <span>需求描述：</span
          ><span>{{
            itemByNeedNo.publishContent ? itemByNeedNo.publishContent : "-"
          }}</span>
                          
        </div>
           
        <div class="demanddetail">
                              <span>用户反馈：</span
          ><span>{{ itemByNeedNo.notes ? itemByNeedNo.notes : "-" }}</span>
                          
        </div>
        <div class="demanddetail">
                              <span>关闭原因：</span
          ><span>{{ itemByNeedNo.notes ? itemByNeedNo.notes : "-" }}</span>
                          
        </div>
         
      </div>
      <div class="demandneed">
        <button
          @click="changeDialogTitle('关闭需求')"
          v-if="!['ygb', 'ycd'].includes(itemByNeedNo.status)"
        >
          关闭需求
        </button>
        <!-- <button @click="changeDialogTitle('关闭原因')">关闭原因</button> -->
        <button @click="changeDialogTitle('沟通记录')">沟通记录</button>
        <button
          class="createFile"
          @click="changeDialogTitle('新建方案')"
          v-if="
            !['ygb', 'ycd'].includes(itemByNeedNo.status) &&
            tableData.length === 0
          "
        >
          新建方案
        </button>
      </div>
      <div class="line"></div>
      <div class="demandTable">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="bh" label="方案编号"> </el-table-column>
          <el-table-column prop="name" label="公司名称"> </el-table-column>
          <el-table-column prop="channelTypeCode" label="需求类型">
          </el-table-column>
          <el-table-column prop="taxpayerType" label="纳税人类型">
          </el-table-column>
          <el-table-column prop="companyProperties" label="公司性质">
          </el-table-column>
          <el-table-column prop="area" label="公司区域"> </el-table-column>
          <el-table-column prop="solutionPrice" label="办理价格">
            <template slot-scope="scope">
              <div style="color: rgba(34, 175, 107, 1)">
                {{ scope.row.solutionPrice }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="statusName" label="状态"> </el-table-column>
          <el-table-column prop="customerRemark" label="用户反馈">
          </el-table-column>

          <el-table-column prop="operation" label="操作">
            <template slot-scope="scope">
              <!-- <el-button
                @click="handleTableClick(scope.row)"
                type="text"
                size="small"
                >详情</el-button
              > -->
              <el-button
                type="text"
                size="small"
                v-if="scope.row.statusName === '用户驳回'"
                @click="updateSolution(scope.row)"
                >重新提交方案</el-button
              >

              <el-button
                type="text"
                size="small"
                v-clipboard:copy="scope.row.url"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                v-if="scope.row.statusName !== '用户驳回'"
                >复制连接</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      center
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="700px"
    >
      <closePlan
        v-if="dialogTitle == '关闭需求'"
        @tolkParent="tolkParent"
        :channelNeedNo="itemByNeedNo.channelNeedNo"
      />
      <createFile
        v-if="dialogTitle == '新建方案'"
        @tolkParent="tolkParent"
        :itemByNeedNo="itemByNeedNo"
      />
      <detailPlan
        v-if="dialogTitle == '方案详情'"
        @tolkParent="tolkParent"
        :detailComp="detailComp"
      />
      <communication
        v-if="dialogTitle == '沟通记录'"
        @tolkParent="tolkParent"
        :channelNeedNo="itemByNeedNo.channelNeedNo"
      />

      <createFile
        v-if="dialogTitle == '重新提交方案'"
        @tolkParent="tolkParent"
        :itemByNeedNo="itemByNeedNo"
        :updateSolutionNo="updateSolutionNo"
      />
      <reasonClosing v-if="dialogTitle == '关闭原因'" />
    </el-dialog>
  </div>
</template>

<script>
import closePlan from "./component/closePlan";
import createFile from "./component/createFile";
import detailPlan from "./component/detailPlan";
import communication from "./component/communication";
import reasonClosing from "./component/reasonClosing";
import {
  getProgrammeInfoByChannelNeedNo,
  getItemByNeedNo,
  needCloseIcp,
} from "@/api/alicp.js";
import moment from "moment";
export default {
  components: {
    closePlan,
    createFile,
    detailPlan,
    communication,
    reasonClosing,
  },
  data() {
    return {
      //loading
      loading: false,
      //dialog显示隐藏
      dialogFormVisible: false,
      //dialog标题
      dialogTitle: "",
      tableData: [],
      detailComp: {
        bh: "",
        type: "",
        comname: "",
        region: "",
        comaddress: "",
      },
      itemByNeedNo: {
        id: 0,
        uapp_id: 0,
        needNo: "",
        channelNeedNo: "",
        channelUserId: "",
        followManUserId: "",
        followManMobile: "",
        city: "",
        province: null,
        publishContent: "",
        publishName: "",
        publishMobile: "",
        notes: null,
        followContent: {
          content: "",
          followDate: "",
        },
        disposeNotes: null,
        status: "",
        typeCode: "",
        typeName: "",
        channelTypeCode: "",
        channelTypeName: "",
        publisherOnlyCode: null,
        followManName: "",
        followManOnlyCode: "",
      },
      updateSolutionNo: {},
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      ///////参数需动态改变
      getItemByNeedNo(this.$route.query.needNo).then((res) => {
        console.log(res);
        if (res.status == 0) {
          this.itemByNeedNo = res.data;
          if (this.itemByNeedNo.created_at) {
            this.itemByNeedNo.created_at = moment(res.data.created_at).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
      this.getProgrammeList();
      this.updateSolutionNo = {};
    },
    onCopy() {
      this.$message({
        message: "复制成功！",
        type: "success",
      });
    },
    onError() {
      this.$message.error("复制失败！");
    },
    //获取需求类型
    getStatus(type) {
      //'wts未推送,yts已推送,ygj已跟进,ycd已成单'
      let status = type;
      switch (type) {
        case "wts":
          status = "未推送";
          break;
        case "yts":
          status = "已推送";
          break;
        case "ygj":
          status = "已跟进";
          break;
        case "ycd":
          status = "已成单";
          break;
        case "ygb":
          status = "已关闭";
          break;
      }
      return status;
    },
    //获取方案列表
    getProgrammeList() {
      const SOLUTIONTYPE = { GSREG: "公司注册" };
      // return
      this.loading = true;
      ///////参数需动态改变
      getProgrammeInfoByChannelNeedNo(this.$route.query.needNo)
        .then((res) => {
          this.tableData = [];
          console.log(res);
          if (res.status == 0) {
            res.data.forEach((item) => {
              this.tableData.push({
                bh: item.solutionNo,
                name: item.solutionContent.solution.companyName,
                channelTypeCode:
                  SOLUTIONTYPE[item.solutionContent.solution.regType] ||
                  item.solutionContent.solution.regType,
                taxpayerType: item.solutionContent.solution.taxpayerType,
                companyProperties:
                  item.solutionContent.solution.companyProperties,
                area: item.solutionContent.solution.area,
                statusName: item.statusName,
                url: item.solutionContent.confirmUrl,
                solutionPrice: item.solutionContent.solution.price,
                customerRemark: item.solutionContent.customerRemark,
                solutionRegType: item.solutionContent.solution.regType,
                memoInfo: item.solutionContent.solution.memoInfo,
                channelSolutionNo: item.channelSolutionNo,
              });
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    //接收子组件方法
    tolkParent(params) {
      console.log(params);
      this.loading = params.loading;
      this.dialogFormVisible = params.dialog;
      if (!this.loading) {
        this.initData();
      }
    },
    //
    changeDialogTitle(title) {
      this.dialogTitle = title;
      this.dialogFormVisible = true;
    },
    // 重新提交方案
    updateSolution(scope) {
      this.updateSolutionNo = scope;
      this.changeDialogTitle("重新提交方案");
    },
    //点击详情
    handleTableClick(scope) {
      console.log(scope);
      this.detailComp = {
        bh: scope.bh,
        type: scope.type,
        comname: scope.name,
        region: scope.region,
        comaddress: scope.address,
        url: scope.url,
      };
      this.changeDialogTitle("方案详情");
    },
  },
};
</script>

<style lang="scss">
.wendemand {
  width: 100%;
  background: #f5f5f6;
  padding: 0 0 50px 0;
  .wendemandTitle {
    width: 100%;
    padding: 20px 0;
    background: #fff;
    div {
      width: 1200px;
      margin: 0 auto;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 20px;
    }
  }
  .wendemandContainer {
    width: 1200px;
    margin: 30px auto;
    background: #fff;
    padding: 20px;
    .demandmation {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(38, 38, 38, 1);
      line-height: 22px;
      letter-spacing: 1px;
    }
    .demandtime {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding: 20px;
      position: relative;
      div {
        width: 33.3%;
        margin-bottom: 20px;
        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 22px;
        }
        span:nth-child(2) {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;
        }
      }
      .demanddetail {
        width: 100%;
      }
      .demandType {
        width: auto;
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(254, 106, 1, 1);
        line-height: 22px;
      }
    }
    .demandneed {
      display: flex;
      justify-content: flex-end;
      button {
        cursor: pointer;
        margin-left: 10px;
        padding: 7px 19px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid #ff8a01;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff8a01;
        line-height: 22px;
      }
      .createFile {
        background: #ff8a01;
        color: #fff;
      }
    }
    .line {
      border: 1px dashed #ccc;
      margin: 20px 0;
    }
    .demandTable {
      width: 100%;
      flex: 1;
      margin-top: 20px;
      overflow: auto;
      .el-table__header {
        .has-gutter {
          th {
            height: 54px;
            background: #fafafa;
            border-bottom: 1px solid #e8e8e8;
            .cell {
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(0, 0, 0, 0.85);
              line-height: 22px;
            }
          }
          th:nth-child(1) {
            padding-left: 15px;
          }
        }
      }
      .el-table__body {
        .el-table__row {
          td {
            height: 54px;
            background: #fff;
            border-bottom: 1px solid #e8e8e8;
            .cell {
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(89, 89, 89, 1);
              line-height: 22px;
            }
          }
          td:nth-child(1) {
            padding-left: 15px;
          }
        }
        .el-button--text {
          color: #ff6a00;
        }
      }
      .el-table__body-wrapper {
        height: calc(100% - 54px) !important;
      }
      .el-table--fit {
        height: 100% !important;
      }
      /*修改滚动条样式*/
      .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        /**/
      }
      .el-table__body-wrapper::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 5px;
      }
      .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
      }
      .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
      }
      .el-table__body-wrapper::-webkit-scrollbar-corner {
        background: #179a16;
      }
    }
  }
  .el-dialog__header {
    border-bottom: 1px solid #dddddd;
  }
  .el-dialog__body {
    padding-top: 0;
    min-height: 400px;
  }
  .wendemandLoading {
    width: 100%;
    height: 100%;
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 9999;
  }
}
</style>
